<template>
  <v-container py-0>
    <v-card class="fill-height">
      <v-container>
        <v-list-item three-line>
          <v-list-item-content>
            <v-list-item-title class="headline">
              {{ title }}
            </v-list-item-title>
            <v-list-item-subtitle>
              Ajoutée le
              {{
                moment
                  .utc(client.timestamp)
                  .local()
                  .format("DD/MM/YYYY à HH:mm")
              }}
            </v-list-item-subtitle>
            <v-list-item-subtitle>
              <button v-clipboard="() => link">
                Copier le lien vers le formulaire
              </button>
              -
              <button @click="openAdminLink">
                Afficher le formulaire privé
              </button>
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-row>
          <v-col>
            <v-list subheader>
              <v-list-item
                v-for="a in answers"
                :key="a.id"
                three-line
                @click="handleClick(answer)"
              >
                <v-list-item-content>
                  <v-list-item-title>{{ a.title }}</v-list-item-title>
                  <v-list-item-subtitle>
                    {{ a.description }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="font-weight-black">
                    {{ a.value === "0" ? "Non" : a.value }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
export default {
  props: {
    answers: {
      type: Array,
      required: true,
    },
    client: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      answer: [],
    };
  },
  computed: {
    title() {
      return `${this.client.first_name} ${this.client.last_name} (${this.client.mail})`;
    },
    link() {
      const token = btoa(this.client.id);
      return `${process.env.VUE_APP_UI}/${token}`;
    },
    adminLink() {
      const token = btoa(this.client.id);
      return `${process.env.VUE_APP_UI}/admin/question/${token}`;
    },
  },
  beforeMount() {},
  methods: {
    openAdminLink() {
      window.open(this.adminLink, '_blank');
    },
    handleClick() {
      // this.$emit("newClient", item);
    },
  },
};
</script>

<style></style>
